import { Suspense } from 'react';
import { mapCompanyType, useFindCompanySuspense } from '@api';
import { CompanyVenue } from '@features';
import { Grid, Skeleton, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/companies/$id.venues';

const COL_SPAN = { base: 12, sm: 6, md: 4 };

const TRANS_KEY = 'COMPANY_VENUES.EMPTY_STATE';

const CompanyVenuesGrid: React.FC = () => {
  const { t } = useTranslation('companyDetailsVenues');
  const { id: companyId } = Route.useParams();
  const { data: company } = useFindCompanySuspense(companyId, {
    query: { select: (response) => mapCompanyType(response.data) },
  });

  if (company.venueIds.length === 0) {
    return (
      <Text c="dimmed" py="md" data-testid="company-venues-empty">
        {t(`${TRANS_KEY}.MESSAGE`)}
      </Text>
    );
  }

  return (
    <Grid columns={12} gap="md" data-testid="company-venues">
      {company.venueIds.map((venueId) => (
        <Grid.Col key={venueId} span={COL_SPAN}>
          <Suspense
            fallback={
              <Skeleton
                height={220}
                radius="md"
                data-testid="company-venues-skeleton"
              />
            }
          >
            <CompanyVenue venueId={venueId} />
          </Suspense>
        </Grid.Col>
      ))}
    </Grid>
  );
};

export const CompanyDetailsVenuesPage: React.FC = () => {
  return (
    <Stack py="md">
      <Suspense fallback={<Skeleton mih={120} />}>
        <CompanyVenuesGrid />
      </Suspense>
    </Stack>
  );
};
